// The signed-in person as the shell shows them: initials from the display
// name, falling back to the username.
import { computed } from "vue";
import store from "@/store";
import { initials } from "@/kit/people.js";

export const me = computed(() => {
  const u = store.state.loggedInUser;
  if (!u) return null;
  const display = (u.display_name && String(u.display_name).trim()) || "";
  return {
    username: u.username,
    name: display || u.username,
    initials: initials(display || u.username),
    picture: (u.picture_link || u.picture || "").startsWith("http") ? u.picture_link || u.picture : null,
  };
});
